import { useEffect } from 'react';
import { Crosstab } from '@hotjar/webapp/utils/crosstab';
import { setRecordingAsWatched } from '../utils';

import type { Store } from '../../../store/list/types';

type CrossTabPayload = {
  recordingId: number;
  value: boolean;
};

export const useCrosstab = (store: Store): void => {
  useEffect(() => {
    Crosstab.listen(
      'recordingDeleted',
      function (data) {
        const {
          setSelectedRecordings,
          setTotalRecordingsCount,
          setTotalHits,
          setRecordings,
          totalRecordingsCount,
          recordings,
        } = store.getState();
        const newTotalRecordingsCount = totalRecordingsCount - 1;
        const newRecordings = recordings.filter(function (r) {
          return r.id !== (data as CrossTabPayload).recordingId;
        });

        setSelectedRecordings([]);
        setTotalRecordingsCount(newTotalRecordingsCount);
        setTotalHits(newTotalRecordingsCount);
        setRecordings(newRecordings);

        window.dispatchEvent(
          new CustomEvent('hjNotification', {
            detail: { cls: 'notification-box-info', message: 'Recording deleted', timeout: 6000 },
          }),
        );
      },
      true,
    );

    Crosstab.listen(
      'watchingRecording',
      function (data) {
        setRecordingAsWatched(store, (data as CrossTabPayload).recordingId);
      },
      //   In the angular controller this value wasn't explicitly passed.
      //   Since it's mandatory, it's value will be set to false.
      false,
    );
    // We just want to run this effect on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
